import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../app/axios";

export const fetchTermGrades = createAsyncThunk(
  "termGrades/fetchTermGrades",
  async (studentId) => {
    const response = await axios.get(`/termgrades/${studentId}`);
    return response.data;
  },
);

const termGradesSlice = createSlice({
  name: "termGrades",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTermGrades.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTermGrades.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload || [];
      })
      .addCase(fetchTermGrades.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default termGradesSlice.reducer;

